import React, { useState } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import './GlobalStyles.css';

const ProjectManagerLookup = () => {
  const [projectNumber, setProjectNumber] = useState('');
  const [projectManager, setProjectManager] = useState('');
  const [company, setCompany] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { instance, accounts } = useMsal();

  const fetchProjectManager = async () => {
    setError('');
    setProjectManager('');
    setCompany('');
    setLoading(true);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Extract the part before a dot if one exists.
    const baseProjectNumber = projectNumber.split('.')[0];
    let lookupProjectNumber = baseProjectNumber;

    // If the project number starts with "PN" (case-insensitive), remove those two characters.
    if (/^pn/i.test(baseProjectNumber)) {
      lookupProjectNumber = baseProjectNumber.slice(2);
    }

    // Debug line to see the project number being searched for
    console.log('Lookup Project Number:', lookupProjectNumber);

    try {
      const tokenResponse = await instance.acquireTokenSilent({
        scopes: ["https://database.windows.net/.default"],
        account: accounts[0]
      });

      const response = await axios.get(`${apiBaseUrl}/api/sesd365/data`, {
        params: { projectNumber: lookupProjectNumber },
        headers: {
          Authorization: `Bearer ${tokenResponse.accessToken}`
        }
      });

      if (response.data && response.data.length > 0) {
        setProjectManager(response.data[0].ProjectManager_NameAlias);
        setCompany(response.data[0].CustomerName);
      } else {
        setError('No project manager found for this project number.');
      }
    } catch (err) {
      setError('Error fetching project manager: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lookup-container">
      <h1 className="lookup-title">Project Manager Lookup</h1>
      <div className="lookup-form-group">
        <input
          type="text"
          className="lookup-input"
          placeholder="Enter Project Number"
          value={projectNumber}
          onChange={(e) => setProjectNumber(e.target.value)}
        />
      </div>
      <div className="lookup-form-group">
        <button className="lookup-button" onClick={fetchProjectManager}>Lookup</button>
      </div>
      {loading && <div className="loading-spinner"></div>}
      {!loading && projectManager && <div className="lookup-result">Project Manager: {projectManager}</div>}
      {!loading && company && <div className="lookup-result">Company: {company}</div>}
      {!loading && error && <div className="lookup-error">{error}</div>}
    </div>
  );
};

export default ProjectManagerLookup;
